import React from 'react';
// import { cn } from "../shared/Utils";

export const Icons = {
  Padlock: (props) => <Padlock {...props} />,

  QrCode: ({ ...props }) => (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      stroke="none"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="70" height="70" stroke="none" fill="#1E1E1E" />
      <g clipPath="url(#clip0_0_1)">
        <rect
          width="1728"
          height="4088"
          transform="translate(-1211 -761)"
          stroke="none"
          fill="white"
        />
        <rect
          x="-15"
          y="-76"
          width="159"
          height="163"
          rx="4"
          stroke="none"
          fill="#DFFDF9"
        />
        <rect
          width="70"
          height="70"
          rx="3.41937"
          stroke="none"
          fill="url(#pattern0_0_1)"
        />
      </g>
      <defs>
        <pattern
          id="pattern0_0_1"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_0_1" transform="scale(0.00666667)" />
        </pattern>
        <clipPath id="clip0_0_1">
          <rect
            width="1728"
            height="4088"
            stroke="none"
            fill="white"
            transform="translate(-1211 -761)"
          />
        </clipPath>
        <image
          id="image0_0_1"
          width="150"
          height="150"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAYAAAA8AXHiAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAlqADAAQAAAABAAAAlgAAAAAXS0ggAAAZNklEQVR4Ae1dZ4weNRN2PnonQOiEllBCaKKGHggIIYQSEIQaIgiCIEChCCQQPwDRRfsBhNAFSAEBQiJBtIgOQRBK6BAglNBD7+0+P0u8ssfP3utd7969954t3e16djyenZ3XO56dsQd06aJSSRKoWQL/q5leIpckkEkgKVZShEYkkBSrEbEmokmxkg40IoGkWI2INRFNipV0oBEJJMVqRKyJaFKspAONSCApViNiTUSTYiUdaEQCSbEaEWsimhQr6UAjEkiK1YhYE9GkWEkHGpFAlGKNGjVKDRgwoFf/nn/+eU8wTz/9tMPT4MGD1T///OPhVQWE0h85cqTDx9ixY506ZDdr1iyPjZkzZ3p4PS3nvffe2+OrDCBKsWbMmFGmr0Zw58yZ49GdO3euA/vkk0/UH3/84cBiKqH0H3/8caebhRZayKmj8vbbb3swdk8eUsOAhx56KKqHKMWK6jk17mgJJMWq8HjxWqqr/O9/nfkIFq5LQIbONttso5ZccklTrfX43nvvqc8++6wlzSFDhqjjjz/ewWOvIQdhQeW3335zXpuLL764+v3333PUhRdeWO26667q1FNPVX///XcGX3nllek9T5w4MW+Hk80331ytsMIKCjRQFllkEbXbbrtl563+rbHGGgr31UT59ddf1QsvvFAvacS8Vy2aE8TL538bb7xxVVJB7R577LG8L9Pvbbfd5rUFzFw3x19++cXDkwCtQF16NHLaXnjhhU4d9D788EPZlNZN3+Z42GGHUTwJZPw/9dRTEq3W+oYbbujdZ0wHtY7DSy21lJZhc2WZZZbxiNf5WsIIpIXp9MFeVRjVqhRGK5ROU28B0//SSy9tTms51qpYtXCUiHSEBPqNYtl2UtGTYyPKv//+W4TeEi5HcNhr/aXUarzL1wiE+MMPP6irr75a/fnnn6Vkutlmm6n999/facPoM9gWW2yhLr/8cqftq6++mjkdDRDG8NChQ001Oy6xxBKZw/LHH3/M4XgFTZ48Oa/jZJVVVnHqRZWXX35ZzZs3L7uMV/bw4cPVSy+9pAx9TCgw2amqcHfddZd68803i7qn8EUXXVRNmjSJTjZog6pA/WAqF92nY/BtvfXWHq1rrrnGwZFtiur6IXu0XnzxRY/W7bff7uEx4/eggw5y2mrl8NoxwCuvvOK0A7/6YTLUlrCff/7ZoxXKv/bQO/QZrSJZSvgNN9zg0EJlq6228njzkEoAGn8VVjWuqxrIWoi0SHfDl19+SfEkEL/wdiwYXauWOj9vFfHQuGIVdZzgnS2Bfq1YcAxWKWXtRdMHmxzASdqJpVbjvV0EpG09dd111znsLL/88pnxbAOnT5+uBg0alIGMcb3iiivaKNl1ORHAB237A/Nyyy2nttxyS6cdKvhSII13RDNI491r2AGAjlQsbeSrY4891nk8Bx98sJo6daoDk5Xx48erm2++2QF//fXX6pRTTnFg559/vjrrrLMcmPbsezOtnXfeWdm2HKPvEOmgSr9+FcrnGGrUmm99sr2s20qFa6H0JZ2+WE+K1RefWh/guSMVq+7vXiHP8dtvv/XQVl11VQeGKIj+UjrSxho9erT6/vvv8w/KsJMefvhhz8Ot/X3Oc95+++2dOiow+mUIzgYbbKCOPPJIB3fatGlONOimm26qPvroI2XPPJdddll1wQUXqK+++iprixkh7LfVVlvNodUJlY5ULDwYzNRMgXKcc8456o477jAgeoQNdNxxxznXvvvuO6W/HjiwtddeW916660ODA5dfGIxZbHFFlNHH320sh2sUHZp9OtwFTVhwgTTrGOOHfkq7I2nIz37LMae+axiPOi9cZ+hfSbFCpVUwislgcYVC7ZGlVK1HesLWTpVw18QyWC/VkGfedClK4GFHCOKYa211nJYrBpuDB6qyqhqO4fxFpXGbawdd9wxN6Jb8FLbZeT9wTlpFzhIqxR44mEbyXLaaadJkLrzzjs9mA3A6/Ljjz+2QVHns2fPjmrfZOPGR6wmmS+iLfP+ivASvDkJdKRiNSeuRDlUAkmxQiWV8EpJoFYb64svvnC++pfiJAAZYb0hZf3111cyp2/YsGHKzvL566+/PNtvxIgRlLyO1sxzCPGdkHn2MTkwUQsggpBm24dlCNt5izDA4TQNKTr9y6Ef0qYMzueff14GvTVuiWhTD1VT98JZexoWGtqrZ4YO/1qQHu+HH364g4MKcgjlPbG8whNOOMHB005UjxbLW7z//vs9PBZaLXnoibrHWAlAv3kVIgPZLvI7nn3NPrc/yRg4C5uWM0d8zpGF5S0i2aQTS79RrE58eO18T31eseSnFAibfTphePLB6JFegigtRl+mcMmcQhBmjlVGK4RXj9E2AwzAa7MqTwiz/emnn6o2r6Xddtttp+T3NryqsMiF8bYXhQ5fccUVDg/rrrtupkhGKfCAdVqUQk6i+faHj8voUyrJN998o15//fWcHstbxMWQvEJEo9a+SEfOWdhJkczCWisVpVihnbQrnkxNY+HLenKg9GIe7XoLbctXn38Vtq1k+zljSbH6uQI0dftJsVpIlhnXLZqky1oCUTaWnTcHaa600koKRqwpMH5DF71AuzfeeMPxhsuJweqrr+5MFsrQNzzZxylTptjVLKQFBn93xjsaIILU9lPFGroOEwUVKZ+QyQFIIUxHLhyC0Op3333X6WmdddZR8+fPz2FF9HOEViclnKkeKhbW0PTzvwMPPDA/N3DmGfcIacAhhxzitTU0zFEb1x5OKH3Wp6FrjszzrpXd65Ot8heyYiDjIRQm5cMWNWELhegYe4//iy++2INVXTSliP+oV6HMmwvNt9MP0ivt4LuRs0SPyQUA6WoowqsTLuUjZV/Ul2wXihdKv4helGIVEU3wJIG2UayBAwdWehoybLgMEfm9kOX92RERhjYbsVheocGv4yjlI3mvo486aUQZ7zLfDivp6YXKHP7GjRunWL6eg6QrMuwE1+Uwjlet8YDjOh4wCzv59NNP1VVXXaUQGoMChTnzzDOzc/sfVo2xPzKDFlMaO2wG+PDEyzBk3KO9ywTiypH+JYudV4hr2FrkwQcfzNEwcTj77LO9HEgpHxaWA9mcfPLJOS2cjBkzRmF1RHtxXHw9sOWIvMsHHnhAYc0Lu9xyyy12tdx5kfEVAtc9OUagNDBxPca4DuGB4eilKR2+wIeOImColWAsrEUav/rhebR1jqLHF5sI6CUmvbYhAGa8h8ofS4XL5xnSZxFO27wK9U3VVtgoFjOxCGFMjq72iGDaM58YGyExovT10pGK1dcfSifwH6VYMndO5tZBQFXz5mKEC2efXeAklGEt9vWmzvVOGg5pFlotRyxMRtgkwiFUUKmatxiTd1nAijY+Gi56AYwuLSzn/X3ppZc6dc1cF3N+Am7/MZxLLrnEwUFf2kvt3dVll13m4Nl0zbkOo/HaMQCzsRhvhq45Mpxrr722sv2nf9jOPYXyj+1TDE/myHhj9x4KixqxNFMtC2YcMvzWxEm1bByAIGmhL7Oai90ca663KmxEadUm9jrcGcwmDKFrL1cJ/FD+eyLvsnHFChFQwuk8CTSuWNKGaGcRypldEa+hn36K2tvwOuUTyr/df1PnteYVgkmZNwdDGs5JhNuaAofdMcccY6rZ2pxYdbjVNBurIcPRZwtwo4028hZGw3pYsmCiIb3oUBDjAsADPvTQQ2WzrG47SOG2kPsVIvsGfMg8QtA09EEI/GOREVNwDXyxghxF85qHXGT4NdroHSbUa6+9ljUP5R/PAV576dzWWwK2lD/jsxAWaoyF4IXmzTFazLmqmXaMTP3gvaZ6s3EHB23YliSIXJD0dIKtR08CQvMKwVsV+rI/1O+55x6Hlv4BdOmvBAy1JYzxHzp5akm8G4RaX4UxeXMhrwSGI0ch/XCDiz16FDWyP/kYHJZXyHgLoW9o2kfZp35++ecpGy/kXNJCGzMShrSvilOrYlVlIrXrPAk0rljMaVpVjPjlysK2H2Ew6SA1UaKSnqzbNpK5xmBV6RuaTR0Zr031ZdONim6wCeEc0QQ33XSTA8YG2wgxNjcIQ5Tl5d17771OdACISIMVeX8IH5GLcjz55JNOnzvssEM2iTBAeLPhfbfz/tZcc036VUDm/bG8Qkw+gGd+NIx+TGgvoiSeeOIJw352RKREle+deO1pOzSPZsCPDs/gmWeecehjIZX333/fgbGIEAehu0o39lfpSwjP1X05f9IzjusI95WFGdeSFvMOX3TRRU5/aKO3JPFgIaHDodEBeluUSvTlPRfVmWc/hP8iehKuw2E8/tnkSbYrU2/8VcgMxTr9QFqRvFLll+0R6QbQNP1uuq7lku2uqYUgIdK4YpE+E6gfSKBWxWLTcDY6GXvLlq80fu1rZc/ZKBnyK2UuA8arsa1svkI2M7fxuztn9LvDL3uN3ZOUWejkpqjvKONd5hXqd3C2R5/dGQxdeJGNVxqGY4jxiw/Jcs0pGODwvFcx3kP3E0S+oFmZD8oojXcYv7iXZ5991r7NDI/NRm0kbG0iV87DzhTvvPNOjgYayJ80HnVz4aijjgoy3uXkg+V1ykVT0IfMCY2ZfGQ8lzHIJC5y2zSR/I/lFeqtQWSzrhDjlxnSLO+PbQYOWEiR/I8fP95rxvIKQz3XtmxwHjr5YHl/IcY7k1loaLJ345GAqFehzD1jRi17BTG8TMutf2woZq9VMxJaTfPR0Yaxc8l/6CtIvjYY7f4Oi1Ks/i68dP/FEohSLJnbxn7JcB7KwhINWF6epM9CdhF5UKVghWdZGP9V6UvaZeqMD2ZwS5ps9Gbyl+2aqEeFzcj9+HDzkydPzvnELAs3i63UtI2QwSG0PfbYo5b9/kBw991390JAWNgMjO277747/wCLrwRyz0EY6vBw26/vffbZx1vaG30aAx88IEp2xowZSi6gq52OCl8eTMFCHHL2i1xMKLmd9wc52tvbYcLDFOvGG2/MjXzIWttwWZ6k+eECVjU61fBc+Rhpo7Vsrpc8zI17zWR2zozfqnl5zMvOwmb23Xdfjw/DjzmGGteMPvtyIIUDA9z0ZY7wslctWuEcegcccEBVUrW3i3oVauG0LPYv0SCzod4eJYBnfnWmDY7sVxsyEUBbNooB3peLlBGTdW/dX+OK1Vs3lvrtXQm0tWLJqAXYJ3CS2kWP4XY121uQGfkOUomK9MbDGGb0pQO2KOS4RNctUWUfcIa2Tan95SoIMgejXgTDwdJ7+HWx0F4tJMeGCM2bc4gvqLC1CR599FEHVYeqOP2hf5b3J/PytLJ36ehZhxarhNpYVemzPmVep/5h0LxL1jYG1isj1uDBg50fFkYhOTI4CAsqoXlzrC2DYXZqF8wKZWF5f3PnznXQkEks7R0HoWSlTvoyr7Mo77Ikiy3Re0WxWnKVEPq8BBpXLDYShcJ6WrrskxHjleH1NK+h/TH+GSyUXihelIMUX+LtLBC4A8xiZ2AANyDzCvENEKsOy7w55LnBwajf6xnvoGPOzc3A2YjXBPZpNgXOQ5sHuB9k9ANwsUe0dE1g7+jhw4cbUpkzUfvF8hR93A8MZHjfkYGEAhoyrxDGPCYWdjQGpv7SEw6XinTKDho0SOGbpXEVwJHM8v4Qrjx06NCcV5zIb5ts4bgi+TuEdAUuINvpy/iXbbqtxxho2JNPE8//WHQD248vJG+O7SfIwmdZ6DPbT5AZ7zbvOD/xxBM9cbC8PEY/ZL9CZryz0GoW3cCctyH8ezdUAAjhv6ApBUe9Cu21zvVNeiMCYHJBEMDsEQZ1zZkz0gEmvxMCxgpztrKAQ9ZWwuwRx1yTvALO6Mu2UjaGXpNHyUOZvmTbWP6jFKsM4wm3f0kgSrFkzBQbPdhnGAaTn3TwGELoM0Oa0ceoWKUwWgzG6MvRjo10VXgqasN4KMJtGl5raLIMb4WyhITGwpstPde4cRn6DKMdxrtdsJgFVkk2hYU+wyCG8f3BBx8YtOxoDGYDRG7dqFGjTDU74sdi5+UV0ce9ytcH/HN2mj0mJM8995xDHwuFwNdkKyvbkkSGNaONPVECUfgHwa/5QRbJ32FgQWXatGlqzpw5zqVJkyY59VIVreUdV1joc4jxy0KfmXCq0mc83KJz/KoUFobM6IeGJodEZ5ThM+pVWEqDexBZuhXq7rpO+swECOHXjEohuL2B05GK1RuCTH26EuhIxbLtFfd2+18tVBYysjV2RIwy3rGIBD7A9mbZdtttc6+14YPlzcGw1TtDGJQsHHjevHl5HSfrrbeeZ7w7CAsqWFxER0Y4l7Cin47ScGDIzbP9ccx432uvvdQmm2zitAP/2H7EeNaLJjchm6WzyZPT2YIK9kO0F03p1bxCzVPude+t86lTp5axKXNcZvweccQR+fXuTtiiHeyrADztdsEy4VJOLDSZTQ4kLdCVtPB1oV1Kn38Vmm94WsilSuxQH9KZdGfIZZmKaFSdHDCfXlEfTcP7vGI1LaBEv5oE+rVi2fYPxMdCjplYWfSE/OogaTM6RTBGP8QIlzwU0e8JeFTYjGQQnne9VoNnTEu8qvVHHnlEYb+/VkXuVwh8hNxgn0FTsJ8gPOX2ZxeWg4dVZM4777w8LxKvUOwniI+2/5k5/1HEg7dzKuVrEFjwWY0fP/6/Bgv+Y8Igy+jRox368PYzxZK0WF4kaN13331OFwyG/RZnz56d4xXtt5gjtDqJMfY0bceA1J8nYsi1bKtnSk5/6J95ltl+hSF5i4wBlhdZdT9BFjbDjHfGB4NJ+TPPe2hYTlX5ML4A68hXIRt5pIc7NEadjTwYQTqtVJVPkRw6UrGKbjbBe04C/UaxjLPRiFbm5Bm4PEqnJ64zmGzH6izLCCtK2yHBrB2DSQctwykDqyqfoj4aVywsKw3/Stm/kA3Ki26KwU866aTM2Nav/+yITSpHjhzp8DV27FinDp5tg9/QBUzeDxYAkTBZ17afIZEfoVTwrNu4OtzaqeOapL/nnnvmNMwJcgwwcTH3iOMZZ5zh1AE7/fTTPRg2T7fbyU08TR+hx8YV66233grlxcFDDFSdhcV7yf3+pJ1RZ/89QQv841NMO5TGFasdbjLx0PMS6EjFwqujP5Z2GnFrdZC2y8MMyfuDM1Du2YdF0PA9z35ACBMeN26cc2tY6VjmByLEuNVOZFgtWroqQAuLvZkkUnjP0aekD+enzFOEh944TtEe+y0iMsK4UgBjrhfcjJ3XiTro2KHOcLPI/oAXXLTBVrnoThyHJXOQYlENiRdal4yFOkhlO9Rl3hzjge2HOHPmTI9/lvenw4dYtw5Me/o9WnpVPgcHFb3BpYfHoifkfouh+0XKvE7IQjpIkTMaUzryVagF5RWZN+chaIAZNexrrUYhgyuXiTRw+4hPXrKwUUGOarKNqduJGoAh0kMrg7mcHUPyOoFoj9Koy8QQwMqUfqNYZYSScOMlkBTLkqH8teOSsWEstFpPpWMSxBlMRi6weDI24obyH0K/zI13pPHOBABjeKeddnIu2ZENuID9EKdPn+7k5cFoxorLxiDGQih4VWHxELuEPEAE8Ml26BO5huaViH7W0Ru0S7wRI0Y4KynDX2XnXWImjAVOZs2alXvy8Xpjq/xhkiLDmgGzV2qO9ofFGGhasI6R2c7Ge8iiICw6gEVPIBdQ3jsLHZayZeHQbCLAYPPnz5fkukK2bPEaaQALrWb0WdtQWHoV2sNO4Lk0dAObRaHJLBoQq7plC2OE0Wd4obCkWKGSSnilJNC4YtX9Syh1dxayHsKtWtwps6dCRjFmXDO+pCENbiV9/er1boLR8pA0oCr/jFYRrHHjfcyYMVnuIZvpFDEF+LBhw7q73O01mZeHh4DIBXjHuyswmrERul3sLUsMfL/99ss2AzcKgOgEhL9oZ2ruR2J5efDq28Y16KFPuRAJFj+xozsYfeznKA18LGqCKAU7OJEtmqJ36ajEv7n/oGOoMcbwdAeOEcuMd9auKizU887y8phhLvlnOMx4Z/xLzzgM6zqLpC95R53xz1Y8ZJu9S/qx/Df+KtQ33OOlal5eDKPyVSUN6xjaaCvph9Izo6qNzz7SS/qx/HekYtlCTOe9I4FaFYsZlHXeFlYvlkW/biSo1jrsm5AycOBABy0mr9Ah1ECFyZGNbDFd12q8I1qULdIRw6DdFp5mWdiwDiN24sSJDuqECRPUlClTHJis4BWqozFycFHYicxbRKLrlVdeqc4999y8rW1A58CIE8Toyw/imKTYBV8J5CychfhgMZTrr78+b4qJ1S677JKFSOfA2JMYA1P37RjvvVFnxjXzLId4xkNlwfIWdRRBaPNKeGzFPSlvZryH5hVK4x20Y0qtr0LNTL8oLHiuNyYM7SzspFjt/HT6MG9RiqXXk+r1Wx8yZIjHA5yOdsHqxdL2sK+XPW+aPuOHZRkxvKow6cCGTRdTolb0i+k4te1sCUSNWJ0tmnR3MRJIihUjvdS2UAJJsQpFky7ESCApVoz0UttCCSTFKhRNuhAjgaRYMdJLbQslkBSrUDTpQowEkmLFSC+1LZRAUqxC0aQLMRJIihUjvdS2UAJJsQpFky7ESCApVoz0UttCCSTFKhRNuhAjgaRYMdJLbQsl8H+CcxRAmZzp7gAAAABJRU5ErkJggg=="
        />
      </defs>
    </svg>
  ),
  AppStore: ({ ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="44.2 18 128 42"
      enableBackground="new 44.2 -25 128 128"
      {...props}
    >
      <g>
        <path
          d="M168.2,59h-120c-2.2,0-4-1.8-4-4V23c0-2.2,1.8-4,4-4h120c2.2,0,4,1.8,4,4v32C172.2,57.2,170.4,59,168.2,59z"
          fill="transparent"
        />
        <g transform="translate(38, 30) scale(1.2)">
          <path
            d="M29.4,13.6c-1.1,1.2-2.1,2.3-3.1,2.3c-0.9,0-2.4-1.1-3.9-1.1c-1.5,0-2.9,1.1-3.9,1.1c-0.9,0-2.1-1.1-3.5-2.8
        c-1.3-1.6-2.4-4.2-2.1-6.7c0.1-0.9,0.5-2.1,1.2-3.1c1.1-1.7,2.9-2.8,4.7-2.8c1.5,0,2.8,1.1,3.9,1.1c1.1,0,2.5-1.2,4.3-1.1
        c0.7,0,2.8,0.3,4.1,2.4c-0.1,0.1-2.5,1.4-2.4,4.2c0,3.4,3,4.6,3,4.6C31.5,10.6,30.5,12.4,29.4,13.6z"
            fill="#000"
          />
        </g>

        <path
          fill="#000"
          stroke="none"
          d="M68.1,29.6c0.8-1.1,1.4-2.5,1.3-4c-1.2,0.1-2.8,0.8-3.6,1.9c-0.8,0.9-1.5,2.4-1.3,3.8
		C65.8,31.4,67.2,30.6,68.1,29.6z"
        />
        <path
          fill="#000"
          stroke="none"
          d="M94,50.1h-2.2l-1.2-3.8h-4.2l-1.1,3.8h-2.1l4.2-12.9h2.6L94,50.1z M90.2,44.7l-1.1-3.4
		c-0.1-0.3-0.3-1.2-0.7-2.4h0c-0.1,0.5-0.3,1.4-0.6,2.4l-1.1,3.4H90.2z"
        />
        <path
          fill="#000"
          stroke="none"
          d="M104.7,45.4c0,1.6-0.4,2.8-1.3,3.8c-0.8,0.8-1.7,1.2-2.9,1.2c-1.2,0-2.1-0.4-2.6-1.3h0v4.9h-2.1v-10
		c0-1,0-2-0.1-3.1h1.8l0.1,1.5h0c0.7-1.1,1.7-1.7,3.1-1.7c1.1,0,2,0.4,2.7,1.3C104.3,42.8,104.7,43.9,104.7,45.4z M102.6,45.4
		c0-0.9-0.2-1.7-0.6-2.2c-0.4-0.6-1-0.9-1.8-0.9c-0.5,0-1,0.2-1.4,0.5c-0.4,0.3-0.7,0.8-0.8,1.3c-0.1,0.3-0.1,0.5-0.1,0.6v1.6
		c0,0.7,0.2,1.2,0.6,1.7c0.4,0.5,1,0.7,1.6,0.7c0.8,0,1.4-0.3,1.8-0.9C102.4,47.2,102.6,46.4,102.6,45.4z"
        />
        <path
          fill="#000"
          stroke="none"
          d="M115.4,45.4c0,1.6-0.4,2.8-1.3,3.8c-0.8,0.8-1.7,1.2-2.9,1.2c-1.2,0-2.1-0.4-2.6-1.3h0v4.9h-2.1v-10
		c0-1,0-2-0.1-3.1h1.8l0.1,1.5h0c0.7-1.1,1.7-1.7,3.1-1.7c1.1,0,2,0.4,2.7,1.3C115,42.8,115.4,43.9,115.4,45.4z M113.3,45.4
		c0-0.9-0.2-1.7-0.6-2.2c-0.4-0.6-1-0.9-1.8-0.9c-0.5,0-1,0.2-1.4,0.5c-0.4,0.3-0.7,0.8-0.8,1.3c-0.1,0.3-0.1,0.5-0.1,0.6v1.6
		c0,0.7,0.2,1.2,0.6,1.7c0.4,0.5,1,0.7,1.6,0.7c0.8,0,1.4-0.3,1.8-0.9C113.1,47.2,113.3,46.4,113.3,45.4z"
        />
        <path
          fill="#000"
          stroke="none"
          d="M127.4,46.5c0,1.1-0.4,2-1.1,2.7c-0.8,0.8-2,1.1-3.5,1.1c-1.4,0-2.5-0.3-3.3-0.8l0.5-1.7
		c0.9,0.5,1.9,0.8,3,0.8c0.8,0,1.4-0.2,1.8-0.5c0.4-0.4,0.6-0.8,0.6-1.4c0-0.5-0.2-1-0.5-1.3c-0.4-0.4-1-0.7-1.8-1
		c-2.3-0.8-3.4-2.1-3.4-3.7c0-1.1,0.4-1.9,1.2-2.6c0.8-0.7,1.8-1,3.2-1c1.2,0,2.1,0.2,2.9,0.6l-0.5,1.7c-0.7-0.4-1.5-0.6-2.5-0.6
		c-0.7,0-1.3,0.2-1.7,0.5c-0.3,0.3-0.5,0.7-0.5,1.2c0,0.5,0.2,0.9,0.6,1.3c0.3,0.3,1,0.6,1.9,1c1.1,0.4,1.9,1,2.5,1.6
		C127.1,44.9,127.4,45.6,127.4,46.5z"
        />
        <path
          fill="#000"
          stroke="none"
          d="M134.2,42.4h-2.3v4.5c0,1.1,0.4,1.7,1.2,1.7c0.4,0,0.7,0,0.9-0.1l0.1,1.6c-0.4,0.2-0.9,0.2-1.6,0.2
		c-0.8,0-1.5-0.2-1.9-0.7c-0.5-0.5-0.7-1.3-0.7-2.5v-4.7h-1.4v-1.6h1.4v-1.7l2-0.6v2.3h2.3V42.4z"
        />
        <path
          fill="#000"
          stroke="none"
          d="M144.5,45.4c0,1.4-0.4,2.6-1.2,3.5c-0.9,0.9-2,1.4-3.4,1.4c-1.4,0-2.5-0.5-3.3-1.4c-0.8-0.9-1.2-2-1.2-3.4
		c0-1.4,0.4-2.6,1.3-3.5c0.8-0.9,2-1.4,3.4-1.4c1.4,0,2.5,0.5,3.3,1.4C144.1,42.9,144.5,44,144.5,45.4z M142.3,45.5
		c0-0.9-0.2-1.6-0.6-2.2c-0.4-0.7-1.1-1.1-1.9-1.1c-0.8,0-1.5,0.4-1.9,1.1c-0.4,0.6-0.6,1.4-0.6,2.2c0,0.9,0.2,1.6,0.6,2.2
		c0.4,0.7,1.1,1.1,1.9,1.1c0.8,0,1.4-0.4,1.9-1.1C142.1,47.1,142.3,46.3,142.3,45.5z"
        />
        <path
          fill="#000"
          stroke="none"
          d="M151.2,42.6c-0.2,0-0.4-0.1-0.7-0.1c-0.7,0-1.3,0.3-1.7,0.8c-0.3,0.5-0.5,1.1-0.5,1.8v4.9h-2.1l0-6.4
		c0-1.1,0-2-0.1-2.9h1.8l0.1,1.8h0.1c0.2-0.6,0.6-1.1,1-1.5c0.5-0.3,1-0.5,1.5-0.5c0.2,0,0.4,0,0.5,0V42.6z"
        />
        <path
          fill="#000"
          stroke="none"
          d="M160.4,45c0,0.4,0,0.7-0.1,0.9h-6.2c0,0.9,0.3,1.6,0.9,2.1c0.5,0.4,1.2,0.7,2,0.7c0.9,0,1.8-0.1,2.5-0.4
		l0.3,1.4c-0.9,0.4-1.9,0.6-3.1,0.6c-1.4,0-2.6-0.4-3.4-1.3c-0.8-0.8-1.2-2-1.2-3.4c0-1.4,0.4-2.6,1.1-3.5c0.8-1,1.9-1.5,3.3-1.5
		c1.3,0,2.4,0.5,3,1.5C160.2,42.9,160.4,43.9,160.4,45z M158.5,44.5c0-0.6-0.1-1.1-0.4-1.6c-0.4-0.6-0.9-0.9-1.6-0.9
		c-0.7,0-1.2,0.3-1.6,0.8c-0.3,0.4-0.5,1-0.6,1.6H158.5z"
        />
        <path
          fill="#000"
          stroke="none"
          d="M89.6,29.3c0,1.1-0.3,2-1,2.6c-0.6,0.5-1.5,0.8-2.7,0.8c-0.6,0-1.1,0-1.5-0.1v-6.2c0.5-0.1,1.1-0.1,1.8-0.1
		c1.1,0,1.9,0.2,2.5,0.7C89.2,27.5,89.6,28.3,89.6,29.3z M88.5,29.3c0-0.7-0.2-1.3-0.6-1.7c-0.4-0.4-1-0.6-1.7-0.6
		c-0.3,0-0.6,0-0.8,0.1v4.7c0.1,0,0.4,0,0.7,0c0.8,0,1.4-0.2,1.8-0.6C88.3,30.8,88.5,30.1,88.5,29.3z"
        />
        <path
          fill="#000"
          stroke="none"
          d="M95.2,30.3c0,0.7-0.2,1.3-0.6,1.7c-0.4,0.5-1,0.7-1.7,0.7c-0.7,0-1.2-0.2-1.6-0.7c-0.4-0.4-0.6-1-0.6-1.7
		c0-0.7,0.2-1.3,0.6-1.7c0.4-0.5,1-0.7,1.7-0.7c0.7,0,1.2,0.2,1.6,0.7C95,29,95.2,29.6,95.2,30.3z M94.2,30.3c0-0.4-0.1-0.8-0.3-1.1
		c-0.2-0.4-0.5-0.5-0.9-0.5c-0.4,0-0.7,0.2-0.9,0.5c-0.2,0.3-0.3,0.7-0.3,1.1c0,0.4,0.1,0.8,0.3,1.1c0.2,0.4,0.5,0.5,0.9,0.5
		c0.4,0,0.7-0.2,0.9-0.6C94.1,31.1,94.2,30.7,94.2,30.3z"
        />
        <path
          fill="#000"
          stroke="none"
          d="M102.9,28l-1.4,4.6h-0.9l-0.6-2c-0.2-0.5-0.3-1-0.4-1.5h0c-0.1,0.5-0.2,1-0.4,1.5l-0.6,2h-0.9L96.2,28h1
		l0.5,2.2c0.1,0.5,0.2,1,0.3,1.5h0c0.1-0.4,0.2-0.9,0.4-1.5l0.6-2.2h0.8l0.6,2.1c0.2,0.5,0.3,1,0.4,1.5h0c0.1-0.5,0.2-1,0.3-1.5
		l0.6-2.1H102.9z"
        />
        <path
          fill="#000"
          stroke="none"
          d="M108.1,32.6h-1V30c0-0.8-0.3-1.2-0.9-1.2c-0.3,0-0.5,0.1-0.7,0.3c-0.2,0.2-0.3,0.5-0.3,0.8v2.7h-1v-3.3
		c0-0.4,0-0.8,0-1.3h0.9l0,0.7h0c0.1-0.2,0.3-0.4,0.5-0.6c0.3-0.2,0.6-0.3,0.9-0.3c0.4,0,0.8,0.1,1.1,0.4c0.4,0.3,0.5,0.8,0.5,1.5
		V32.6z"
        />
        <path fill="#000" stroke="none" d="M110.9,32.6h-1v-6.7h1V32.6z" />
        <path
          fill="#000"
          stroke="none"
          d="M116.9,30.3c0,0.7-0.2,1.3-0.6,1.7c-0.4,0.5-1,0.7-1.7,0.7c-0.7,0-1.2-0.2-1.6-0.7c-0.4-0.4-0.6-1-0.6-1.7
		c0-0.7,0.2-1.3,0.6-1.7s1-0.7,1.7-0.7c0.7,0,1.2,0.2,1.6,0.7C116.7,29,116.9,29.6,116.9,30.3z M115.9,30.3c0-0.4-0.1-0.8-0.3-1.1
		c-0.2-0.4-0.5-0.5-0.9-0.5c-0.4,0-0.7,0.2-0.9,0.5c-0.2,0.3-0.3,0.7-0.3,1.1c0,0.4,0.1,0.8,0.3,1.1c0.2,0.4,0.5,0.5,0.9,0.5
		c0.4,0,0.7-0.2,0.9-0.6C115.8,31.1,115.9,30.7,115.9,30.3z"
        />
        <path
          fill="#000"
          stroke="none"
          d="M121.8,32.6h-0.9l-0.1-0.5h0c-0.3,0.4-0.8,0.6-1.3,0.6c-0.4,0-0.8-0.1-1-0.4c-0.2-0.3-0.4-0.6-0.4-0.9
		c0-0.6,0.2-1,0.7-1.3c0.5-0.3,1.1-0.4,2-0.4v-0.1c0-0.6-0.3-0.9-0.9-0.9c-0.5,0-0.8,0.1-1.2,0.3l-0.2-0.7c0.4-0.3,0.9-0.4,1.6-0.4
		c1.2,0,1.8,0.6,1.8,1.9v1.7C121.8,32,121.8,32.3,121.8,32.6z M120.8,31v-0.7c-1.1,0-1.7,0.3-1.7,0.9c0,0.2,0.1,0.4,0.2,0.5
		c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.6-0.2c0.2-0.1,0.3-0.3,0.4-0.5C120.8,31.2,120.8,31.1,120.8,31z"
        />
        <path
          fill="#000"
          stroke="none"
          d="M127.6,32.6h-0.9l0-0.7h0c-0.3,0.6-0.8,0.8-1.5,0.8c-0.6,0-1-0.2-1.4-0.6c-0.4-0.4-0.5-1-0.5-1.7
		c0-0.7,0.2-1.3,0.6-1.8c0.4-0.4,0.9-0.6,1.4-0.6c0.6,0,1,0.2,1.3,0.6h0v-2.6h1v5.4C127.6,31.8,127.6,32.2,127.6,32.6z M126.6,30.7
		v-0.8c0-0.1,0-0.2,0-0.3c-0.1-0.2-0.2-0.4-0.4-0.6c-0.2-0.2-0.4-0.2-0.7-0.2c-0.4,0-0.7,0.2-0.9,0.5c-0.2,0.3-0.3,0.7-0.3,1.2
		c0,0.5,0.1,0.8,0.3,1.1c0.2,0.3,0.5,0.5,0.9,0.5c0.3,0,0.6-0.1,0.8-0.4C126.5,31.3,126.6,31,126.6,30.7z"
        />
        <path
          fill="#000"
          stroke="none"
          d="M136.3,30.3c0,0.7-0.2,1.3-0.6,1.7c-0.4,0.5-1,0.7-1.7,0.7c-0.7,0-1.2-0.2-1.6-0.7c-0.4-0.4-0.6-1-0.6-1.7
		c0-0.7,0.2-1.3,0.6-1.7c0.4-0.5,1-0.7,1.7-0.7c0.7,0,1.2,0.2,1.6,0.7C136.1,29,136.3,29.6,136.3,30.3z M135.2,30.3
		c0-0.4-0.1-0.8-0.3-1.1c-0.2-0.4-0.5-0.5-0.9-0.5c-0.4,0-0.7,0.2-0.9,0.5c-0.2,0.3-0.3,0.7-0.3,1.1c0,0.4,0.1,0.8,0.3,1.1
		c0.2,0.4,0.5,0.5,0.9,0.5c0.4,0,0.7-0.2,0.9-0.6C135.1,31.1,135.2,30.7,135.2,30.3z"
        />
        <path
          fill="#000"
          stroke="none"
          d="M141.8,32.6h-1V30c0-0.8-0.3-1.2-0.9-1.2c-0.3,0-0.5,0.1-0.7,0.3c-0.2,0.2-0.3,0.5-0.3,0.8v2.7h-1v-3.3
		c0-0.4,0-0.8,0-1.3h0.9l0,0.7h0c0.1-0.2,0.3-0.4,0.5-0.6c0.3-0.2,0.6-0.3,0.9-0.3c0.4,0,0.8,0.1,1.1,0.4c0.4,0.3,0.5,0.8,0.5,1.5
		V32.6z"
        />
        <path
          fill="#000"
          stroke="none"
          d="M148.6,28.8h-1.1V31c0,0.6,0.2,0.8,0.6,0.8c0.2,0,0.3,0,0.5,0l0,0.8c-0.2,0.1-0.5,0.1-0.8,0.1
		c-0.4,0-0.7-0.1-0.9-0.4c-0.2-0.2-0.3-0.7-0.3-1.2v-2.3h-0.7V28h0.7v-0.8l1-0.3V28h1.1V28.8z"
        />
        <path
          fill="#000"
          stroke="none"
          d="M154,32.6h-1V30c0-0.8-0.3-1.2-0.9-1.2c-0.5,0-0.8,0.2-1,0.7c0,0.1,0,0.2,0,0.4v2.7h-1v-6.7h1v2.8h0
		c0.3-0.5,0.8-0.8,1.4-0.8c0.4,0,0.8,0.1,1,0.4c0.3,0.3,0.5,0.9,0.5,1.5V32.6z"
        />
        <path
          fill="#000"
          stroke="none"
          d="M159.5,30.1c0,0.2,0,0.3,0,0.5h-3c0,0.5,0.2,0.8,0.4,1c0.3,0.2,0.6,0.3,1,0.3c0.5,0,0.9-0.1,1.2-0.2
		l0.2,0.7c-0.4,0.2-0.9,0.3-1.5,0.3c-0.7,0-1.3-0.2-1.7-0.6c-0.4-0.4-0.6-1-0.6-1.7c0-0.7,0.2-1.3,0.6-1.7c0.4-0.5,0.9-0.7,1.6-0.7
		c0.7,0,1.2,0.2,1.5,0.7C159.4,29,159.5,29.5,159.5,30.1z M158.6,29.8c0-0.3-0.1-0.6-0.2-0.8c-0.2-0.3-0.4-0.4-0.8-0.4
		c-0.3,0-0.6,0.1-0.8,0.4c-0.2,0.2-0.3,0.5-0.3,0.8H158.6z"
        />
      </g>
    </svg>
  ),
  PlayStore: ({ ...props }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="185.5 17 128 43"
      enableBackground="new 185.5 -25.5 128 128"
      {...props}
    >
      <g>
        <path
          d="M309.5,58.5h-120c-2.2,0-4-1.8-4-4v-32c0-2.2,1.8-4,4-4h120c2.2,0,4,1.8,4,4v32C313.5,56.7,311.7,58.5,309.5,58.5z"
          fill="transparent"
        />
        <linearGradient
          id="SVGID1"
          gradientUnits="userSpaceOnUse"
          x1="201.7674"
          y1="25.0736"
          x2="207.3656"
          y2="48.0645"
        >
          <stop offset="0" style={{ stopColor: '#006884' }} />
          <stop offset="1" style={{ stopColor: '#8AD1D0' }} />
        </linearGradient>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="url(#SVGID1)"
          stroke="none"
          d="M195.3,38.1V27.6c0-0.6,0.5-1.1,1-1.1c0.5,0,0.7,0.1,1,0.3
		l19.3,10.6c0.4,0.2,0.6,0.5,0.6,0.8c0,0.3-0.2,0.6-0.6,0.8l-19.3,10.6c-0.2,0.1-0.5,0.3-1,0.3c-0.5,0-1-0.5-1-1.1V38.1z"
        />
        <linearGradient
          id="SVGID2"
          gradientUnits="userSpaceOnUse"
          x1="194.9407"
          y1="28.3438"
          x2="210.1967"
          y2="36.5913"
        >
          <stop offset="0" style={{ stopColor: '#24BBB6' }} />
          <stop offset="1" style={{ stopColor: '#DBE692' }} />
        </linearGradient>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="url(#SVGID2)"
          stroke="none"
          d="M207.8,38.2l-11.7-11.7c0.1,0,0.1,0,0.2,0
		c0.5,0,0.7,0.1,1,0.3l14.2,7.8L207.8,38.2z"
        />
        <linearGradient
          id="SVGID3"
          gradientUnits="userSpaceOnUse"
          x1="212.4944"
          y1="42.1201"
          x2="212.4944"
          y2="34.1717"
        >
          <stop offset="0" style={{ stopColor: '#FCC072' }} />
          <stop offset="1" style={{ stopColor: '#F58A5B' }} />
        </linearGradient>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="url(#SVGID3)"
          stroke="none"
          d="M211.4,41.7l-3.6-3.6l3.7-3.7l5.1,2.8
		c0.4,0.2,0.6,0.5,0.6,0.8c0,0.3-0.2,0.6-0.6,0.8L211.4,41.7z"
        />
        <linearGradient
          id="SVGID4"
          gradientUnits="userSpaceOnUse"
          x1="197.8947"
          y1="51.7691"
          x2="209.9464"
          y2="39.5039"
        >
          <stop offset="0" style={{ stopColor: '#712B8F' }} />
          <stop offset="1" style={{ stopColor: '#EA1D27' }} />
        </linearGradient>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="url(#SVGID4)"
          stroke="none"
          d="M196.2,49.7L196.2,49.7l11.6-11.6l3.6,3.6l-14.1,7.7
		C197,49.6,196.8,49.7,196.2,49.7C196.3,49.7,196.3,49.7,196.2,49.7z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#000"
          stroke="none"
          d="M256.6,52.4c-0.5-0.4-0.9-1.1-1.1-1.5l1.6-0.7
		c0.1,0.2,0.3,0.5,0.5,0.8c0.4,0.4,1,0.8,1.6,0.8c0.6,0,1.3-0.3,1.7-0.8c0.3-0.5,0.5-1,0.5-1.7v-0.6c-1.2,1.5-3.7,1.3-5.1-0.3
		c-1.5-1.6-1.5-4.3,0-5.9c1.5-1.5,3.7-1.7,5-0.3c0,0,0,0,0,0v-0.7h1.7V49c0,1.9-0.7,3-1.6,3.7c-0.6,0.5-1.5,0.7-2.3,0.7
		C258.2,53.3,257.3,53,256.6,52.4L256.6,52.4z M298.5,52.8L298.5,52.8l1.7-4l-3-6.9h1.7l2.1,4.9l2.1-4.9h1.7l-4.6,10.9H298.5
		L298.5,52.8z M290.4,49L290.4,49c-0.5-0.5-0.7-1.2-0.7-1.9c0-0.6,0.2-1.2,0.6-1.6c0.7-0.7,1.7-1,2.8-1c0.7,0,1.3,0.1,1.8,0.4
		c0-1.2-1-1.7-1.8-1.7c-0.7,0-1.4,0.4-1.7,1.1l-1.5-0.6c0.3-0.7,1.1-2,3.1-2c1,0,2,0.3,2.6,1c0.6,0.7,0.8,1.5,0.8,2.6v4.2h-1.7v-0.7
		c-0.2,0.3-0.6,0.5-0.9,0.7c-0.4,0.2-0.9,0.3-1.4,0.3C291.8,49.7,290.9,49.5,290.4,49L290.4,49z M237.1,45.4L237.1,45.4
		c0-2,1.5-4.2,4.2-4.2c2.6,0,4.2,2.2,4.2,4.2c0,2-1.5,4.2-4.2,4.2C238.6,49.6,237.1,47.4,237.1,45.4L237.1,45.4z M246.1,45.4
		L246.1,45.4c0-2,1.5-4.2,4.2-4.2c2.6,0,4.2,2.2,4.2,4.2c0,2-1.5,4.2-4.2,4.2C247.7,49.6,246.1,47.4,246.1,45.4L246.1,45.4z
		M225.8,47.6L225.8,47.6c-2.5-2.5-2.4-6.6,0.1-9.2c1.3-1.3,2.9-1.9,4.6-1.9c1.6,0,3.2,0.6,4.4,1.8l-1.2,1.3
		c-1.8-1.8-4.7-1.7-6.4,0.1c-1.8,1.9-1.8,4.8,0,6.7c1.8,1.9,4.8,2,6.6,0.1c0.6-0.6,0.8-1.4,0.9-2.2h-4.2v-1.8h5.9
		c0.1,0.4,0.1,0.9,0.1,1.4c0,1.5-0.6,3-1.6,4c-1.1,1.1-2.7,1.7-4.3,1.7C228.9,49.5,227.1,48.9,225.8,47.6L225.8,47.6z M268.1,48.3
		L268.1,48.3c-1.5-1.6-1.5-4.3,0-6c1.5-1.6,4-1.6,5.4,0c0.5,0.5,0.8,1.2,1.1,1.9l-5.5,2.3c0.3,0.7,1,1.3,2,1.3
		c0.9,0,1.5-0.3,2.1-1.2l1.5,1h0c-0.2,0.2-0.4,0.4-0.5,0.6C272.5,49.9,269.6,49.9,268.1,48.3L268.1,48.3z M278.5,49.5L278.5,49.5
		V38.4h3.6c2.1,0,3.8,1.5,3.8,3.3c0,1.8-1.5,3.3-3.4,3.3h-2.2v4.4H278.5L278.5,49.5z M286.9,49.5L286.9,49.5V38.4h1.7v11.1H286.9
		L286.9,49.5z M264.3,49.3L264.3,49.3V36.9h1.8v12.4H264.3L264.3,49.3z M294.8,46.2L294.8,46.2c-0.4-0.3-1-0.4-1.6-0.4
		c-1.2,0-1.9,0.6-1.9,1.3c0,0.7,0.7,1.1,1.4,1.1C293.7,48.2,294.8,47.4,294.8,46.2L294.8,46.2z M243.6,45.4L243.6,45.4
		c0-1.2-0.8-2.5-2.3-2.5c-1.5,0-2.3,1.3-2.3,2.5c0,1.2,0.8,2.5,2.3,2.5C242.7,47.9,243.6,46.6,243.6,45.4L243.6,45.4z M252.6,45.4
		L252.6,45.4c0-1.2-0.8-2.5-2.3-2.5c-1.5,0-2.3,1.3-2.3,2.5c0,1.2,0.8,2.5,2.3,2.5C251.8,47.9,252.6,46.6,252.6,45.4L252.6,45.4z
		M261.5,46.1L261.5,46.1c0-0.1,0-0.2,0.1-0.3c0,0,0,0,0,0c0-0.1,0-0.3,0-0.4c0-0.1,0-0.3,0-0.4c0,0,0-0.1,0-0.1
		c0-0.1-0.1-0.3-0.1-0.4c-0.3-1-1.2-1.7-2.1-1.7c-1.2,0-2.2,1.2-2.2,2.5c0,1.4,1,2.5,2.3,2.5C260.3,47.9,261.1,47.2,261.5,46.1
		L261.5,46.1z M268.8,45.2L268.8,45.2l3.7-1.6c-0.4-0.7-1-0.9-1.5-0.9C269.5,42.8,268.6,44.4,268.8,45.2L268.8,45.2z M284.1,41.8
		L284.1,41.8c0-1-0.8-1.7-1.9-1.7h-2v3.5h2.1C283.3,43.6,284.1,42.8,284.1,41.8z"
        />
        <polygon
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#000"
          stroke="none"
          points="299.8,50.8 299.8,50.8 299.7,50.8 299.7,50.8 299.7,50.7 
		299.7,50.7 299.8,50.7 299.8,50.7 299.7,50.7 299.7,50.7 299.7,50.8 299.7,50.8 	"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#000"
          stroke="none"
          d="M299.8,50.8L299.8,50.8C299.8,50.7,299.8,50.7,299.8,50.8
		L299.8,50.8C299.8,50.7,299.8,50.7,299.8,50.8L299.8,50.8L299.8,50.8L299.8,50.8L299.8,50.8L299.8,50.8L299.8,50.8L299.8,50.8
		L299.8,50.8z M299.8,50.7L299.8,50.7C299.8,50.7,299.8,50.7,299.8,50.7L299.8,50.7L299.8,50.7L299.8,50.7
		C299.8,50.7,299.8,50.7,299.8,50.7L299.8,50.7z"
        />
        <polygon
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#000"
          stroke="none"
          points="299.8,50.8 299.8,50.8 299.8,50.7 299.8,50.7 299.8,50.7 
		299.8,50.7 299.8,50.7 299.8,50.7 299.8,50.7 299.8,50.7 299.8,50.8 299.8,50.8 	"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#000"
          stroke="none"
          d="M299.8,50.8L299.8,50.8L299.8,50.8L299.8,50.8L299.8,50.8
		L299.8,50.8L299.8,50.8L299.8,50.8L299.8,50.8L299.8,50.8z M299.8,50.7L299.8,50.7L299.8,50.7L299.8,50.7
		C299.8,50.7,299.8,50.7,299.8,50.7C299.8,50.7,299.8,50.7,299.8,50.7L299.8,50.7z"
        />
        <polygon
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#000"
          stroke="none"
          points="299.8,50.7 299.8,50.7 299.8,50.7 299.8,50.7 299.8,50.8 
		299.8,50.8 299.8,50.7 299.8,50.7 	"
        />
        <polygon
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#000"
          stroke="none"
          points="299.8,50.8 299.8,50.8 299.8,50.7 299.8,50.7 299.8,50.7 
		299.8,50.7 299.8,50.7 299.8,50.7 299.8,50.7 299.8,50.7 299.8,50.8 299.8,50.8 	"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#000"
          stroke="none"
          d="M299.8,50.8L299.8,50.8C299.8,50.7,299.8,50.7,299.8,50.8
		L299.8,50.8L299.8,50.8L299.8,50.8C299.8,50.8,299.8,50.8,299.8,50.8L299.8,50.8z M299.8,50.8L299.8,50.8
		C299.8,50.8,299.8,50.8,299.8,50.8L299.8,50.8L299.8,50.8L299.8,50.8C299.8,50.7,299.8,50.7,299.8,50.8L299.8,50.8z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#000"
          stroke="none"
          d="M299.9,50.8L299.9,50.8C299.9,50.7,299.9,50.7,299.9,50.8
		C299.9,50.7,299.9,50.7,299.9,50.8L299.9,50.8C299.9,50.7,299.9,50.7,299.9,50.8L299.9,50.8L299.9,50.8L299.9,50.8
		C299.9,50.8,299.9,50.8,299.9,50.8L299.9,50.8z M299.9,50.7L299.9,50.7C299.9,50.7,299.9,50.7,299.9,50.7L299.9,50.7L299.9,50.7
		L299.9,50.7C299.9,50.7,299.9,50.7,299.9,50.7L299.9,50.7L299.9,50.7z M299.9,50.8L299.9,50.8C299.9,50.8,299.9,50.8,299.9,50.8
		L299.9,50.8L299.9,50.8L299.9,50.8C299.9,50.7,299.9,50.7,299.9,50.8L299.9,50.8z"
        />
        <polygon
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#000"
          stroke="none"
          points="299.9,50.7 299.9,50.7 299.9,50.7 299.9,50.7 299.9,50.7 
		299.9,50.7 299.9,50.7 299.9,50.7 299.9,50.8 299.9,50.8 299.9,50.7 	"
        />
        <polygon
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#000"
          stroke="none"
          points="299.9,50.8 299.9,50.8 299.9,50.7 299.9,50.7 299.9,50.8 
		299.9,50.8 	"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#000"
          stroke="none"
          d="M299.9,50.8L299.9,50.8C299.9,50.7,299.9,50.7,299.9,50.8 C299.9,50.7,299.9,50.7,299.9,50.8L299.9,50.8C299.9,50.8,299.9,50.8,299.9,50.8C299.9,50.8,299.9,50.8,299.9,50.8L299.9,50.8z M299.9,50.7L299.9,50.7C299.9,50.8,299.9,50.8,299.9,50.7C299.9,50.8,299.9,50.8,299.9,50.7L299.9,50.7 C299.9,50.7,299.9,50.7,299.9,50.7C299.9,50.7,299.9,50.7,299.9,50.7L299.9,50.7z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#000"
          stroke="none"
          d="M299.9,50.8L299.9,50.8L299.9,50.8L299.9,50.8L299.9,50.8
		L299.9,50.8C299.9,50.8,299.9,50.8,299.9,50.8C299.9,50.8,299.9,50.8,299.9,50.8L299.9,50.8C299.9,50.7,299.9,50.7,299.9,50.8
		C299.9,50.7,299.9,50.7,299.9,50.8L299.9,50.8C299.9,50.7,299.9,50.7,299.9,50.8C299.9,50.7,299.9,50.7,299.9,50.8L299.9,50.8
		C299.9,50.8,299.9,50.8,299.9,50.8C299.9,50.8,299.9,50.8,299.9,50.8L299.9,50.8z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#000"
          stroke="none"
          d="M300,50.8L300,50.8C300,50.7,300,50.7,300,50.8
		C299.9,50.7,299.9,50.7,300,50.8L300,50.8C299.9,50.8,299.9,50.8,300,50.8C300,50.8,300,50.8,300,50.8L300,50.8z M300,50.7
		L300,50.7C300,50.8,300,50.8,300,50.7C300,50.8,299.9,50.8,300,50.7L300,50.7C299.9,50.7,300,50.7,300,50.7
		C300,50.7,300,50.7,300,50.7L300,50.7z"
        />
        <polygon
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#000"
          stroke="none"
          points="300,50.8 300,50.7 300,50.7 300,50.7 300,50.7 300,50.7 
		300,50.8 300,50.8 300,50.7 300,50.7 300,50.8 300,50.8 300,50.7 300,50.7 300,50.8 	"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#000"
          stroke="none"
          d="M300,50.8L300,50.8L300,50.8L300,50.8L300,50.8L300,50.8L300,50.8
		L300,50.8L300,50.8L300,50.8z M300,50.7L300,50.7L300,50.7L300,50.7C300,50.7,300,50.7,300,50.7C300,50.7,300,50.7,300,50.7
		L300,50.7z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#000"
          stroke="none"
          d="M300,50.8C300,50.7,300,50.7,300,50.8C300,50.7,300,50.7,300,50.8
		C300,50.7,300,50.7,300,50.8C300,50.7,300,50.7,300,50.8L300,50.8C300,50.7,300,50.7,300,50.8C300,50.7,300,50.7,300,50.8
		C300,50.7,300,50.7,300,50.8C300,50.7,300,50.7,300,50.8C300,50.8,300,50.8,300,50.8C300,50.8,300,50.8,300,50.8L300,50.8
		C300,50.8,300,50.8,300,50.8C300,50.8,300,50.8,300,50.8z"
        />
        <polygon
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#000"
          stroke="none"
          points="300.1,50.7 300,50.7 300,50.7 300.1,50.7 300.1,50.8 
		300.1,50.8 300.1,50.7 300.1,50.7 	"
        />
        <polygon
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#000"
          stroke="none"
          points="300.1,50.8 300.1,50.8 300.1,50.7 300.1,50.7 300.1,50.7 
		300.1,50.7 300.1,50.7 300.1,50.7 300.1,50.7 300.1,50.7 300.1,50.8 300.1,50.8 	"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#000"
          stroke="none"
          d="M300.1,50.8L300.1,50.8C300.1,50.7,300.1,50.7,300.1,50.8
		L300.1,50.8C300.1,50.7,300.1,50.7,300.1,50.8L300.1,50.8L300.1,50.8L300.1,50.8L300.1,50.8L300.1,50.8L300.1,50.8L300.1,50.8
		L300.1,50.8z M300.1,50.7L300.1,50.7C300.1,50.7,300.1,50.7,300.1,50.7L300.1,50.7L300.1,50.7L300.1,50.7
		C300.1,50.7,300.1,50.7,300.1,50.7L300.1,50.7z"
        />
        <path
          fill="#000"
          stroke="none"
          d="M224.4,28.6c0-1.8,1.3-2.9,2.9-2.9c1.1,0,1.8,0.5,2.3,1.2l-0.8,0.5c-0.3-0.4-0.8-0.7-1.5-0.7
		c-1.1,0-1.9,0.8-1.9,2c0,1.2,0.8,2,1.9,2c0.6,0,1.1-0.3,1.3-0.5v-0.9H227v-0.9h2.7v2.1c-0.5,0.6-1.3,1-2.3,1
		C225.7,31.5,224.4,30.3,224.4,28.6z"
        />
        <path
          fill="#000"
          stroke="none"
          d="M230.9,31.4v-5.6h3.8v0.9h-2.9v1.4h2.8v0.9h-2.8v1.6h2.9v0.9L230.9,31.4L230.9,31.4z"
        />
        <path
          fill="#000"
          stroke="none"
          d="M237.5,31.4v-4.7h-1.7v-0.9h4.4v0.9h-1.7v4.7H237.5z"
        />
        <path
          fill="#000"
          stroke="none"
          d="M243.6,31.4v-5.6h1v5.6C244.6,31.4,243.6,31.4,243.6,31.4z"
        />
        <path
          fill="#000"
          stroke="none"
          d="M247.3,31.4v-4.7h-1.7v-0.9h4.4v0.9h-1.7v4.7H247.3z"
        />
        <path
          fill="#000"
          stroke="none"
          d="M253.2,28.6c0-1.7,1.2-2.9,2.9-2.9c1.7,0,2.9,1.2,2.9,2.9s-1.2,2.9-2.9,2.9
		C254.4,31.5,253.2,30.2,253.2,28.6z M257.9,28.6c0-1.2-0.7-2-1.9-2c-1.1,0-1.9,0.9-1.9,2c0,1.2,0.7,2,1.9,2
		C257.2,30.6,257.9,29.7,257.9,28.6z"
        />
        <path
          fill="#000"
          stroke="none"
          d="M264,31.4l-2.9-4v4h-1v-5.6h1l2.9,3.9v-3.9h1v5.6H264z"
        />
      </g>
    </svg>
  )
};

const Padlock = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5 4.63601C5 3.76031 5.24219 3.1054 5.64323 2.67357C6.03934 2.24705 6.64582 1.9783 7.5014 1.9783C8.35745 1.9783 8.96306 2.24652 9.35823 2.67208C9.75838 3.10299 10 3.75708 10 4.63325V5.99999H5V4.63601ZM4 5.99999V4.63601C4 3.58148 4.29339 2.65754 4.91049 1.99307C5.53252 1.32329 6.42675 0.978302 7.5014 0.978302C8.57583 0.978302 9.46952 1.32233 10.091 1.99162C10.7076 2.65557 11 3.57896 11 4.63325V5.99999H12C12.5523 5.99999 13 6.44771 13 6.99999V13C13 13.5523 12.5523 14 12 14H3C2.44772 14 2 13.5523 2 13V6.99999C2 6.44771 2.44772 5.99999 3 5.99999H4ZM3 6.99999H12V13H3V6.99999Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1"
      fillRule="evenodd"
      clipRule="evenodd"
    ></path>
  </svg>
);
